/** Live Tracking reads `?follow=` on load and follows that vehicle. */
export const FOLLOW_PARAM = "follow";

/** The Costs page reads `?due=` on load and opens that reminder's cost (or its rule). */
export const COST_DUE_PARAM = "due";

export function costDueHref(dueId: string): string {
  return `/costs?${COST_DUE_PARAM}=${encodeURIComponent(dueId)}`;
}

export function trackingFollowHref(vehicleId: string): string {
  return `/tracking?${FOLLOW_PARAM}=${encodeURIComponent(vehicleId)}`;
}
